// extracted by mini-css-extract-plugin
module.exports = {"ergonomics-section":"ErgonomicsSection_ergonomics-section__rJAdZ","__title":"ErgonomicsSection___title__xZ7gB","__bento-container":"ErgonomicsSection___bento-container__Kgq_n"};